import Vue from "vue";
import ApiService from "../../services/api";
import gridClientBase from "../../components/gridClientComponentBase";
import moment from "moment";
import { mapGetters } from "vuex";
import cellDeleteCommand from "../../components/grid/cellDeleteCommand/cellDeleteCommand.vue";
import { bus } from "../../main";
import geofenceMap from "./map.vue";
import api from "../../services/api";
import { isTransformerResult } from "@progress/kendo-data-query/dist/npm/transducers";

export default {
	extends: gridClientBase,
	components: {
		geofenceMap
	},
	data: () => {
		return {
			vehicleIdFilterField: "number_plate",
			isGeofenceDetailInEditMode: false,
			geofenceId: 0,
			isNewGeofence: false,

			vehicles: [],
			groups: [],
			groupsDataFilters: [],
			groupsDataFiltersSelected: [],
			divisions: [],
			divisionsFilter: [],
			divisionsFilterSelected: [],
			plateNumberFilters: [],
			plateNumberFilterSelected: [],

			geofenceVehicleTypes: [],
			geofenceVehicleTypesSelected: null,

			id: 0,
			name: "",
			checkIn: false,
			checkOut: false,
			useApiRoads: false,
			saveGeofenceVechilesAssociationRequest: null,
			poi: [{ key: 0, value: "" }],

			itemTemplate: "<div style='height: 50px'>#= number_plate # <br /><div style='font-size: 8px'> #= name # </div></div>",
			valueTemplate: "#= number_plate #",

			days: [],

			startDate: null,
			endDate: null,
			errorsStartTime: [false, false, false, false, false, false, false],
			errorsEndTime: [false, false, false, false, false, false, false],

			datePickerFooter: "Oggi - #=kendo.toString(data, 'dd MMMM yyyy') #",

			options: {
				messages: {
					hour: "HH",
					minute: "mm"
				}
			},

			geofenceVehicleItems: [],

			poiItems: [],
			poiItemsSelected: [],
			poiCategories: [],

			showPoiModal: false,
			geofenceMarker: [],

			configMap: {
				mapInitialLocation: {
					lat: 43.1107,
					lng: 12.3908
				}
			},

			savePendingRequest: null,

			hasDivisions: false,

			columnsTable: [],
			isModalShown: false
		};
	},

	created() {
		var self = this;
		this.geofenceId = this.$route.params.id;
		this.vehicleIdFilterField = this.settings.vehicleIdFilterField;

		this.columnsTable = [
			{
				field: "type_name",
				title: "Tipo Associazione",
				headerCell: "myHeaderTemplate",
				filterable: true,
				width: 200,
				cell: "myGeofenceVehicleTypesCellTemplate"
			},
			{
				field: "vehicle_name",
				title: this.vehicleIdFilterField == "code" ? "codice" : "targa",
				headerCell: "myVehicleNumberPlateHeaderTemplate",
				cell: "numberPlateCellTemplate",
				filterable: true
			},
			{
				field: "group_name",
				title: "Gruppo",
				headerCell: "myGroupsHeaderTemplate",
				cell: "myGroupsCellTemplate",
				filterable: true
			}
		];

		if (this.settings && this.settings.hasDivisions) {
			this.columnsTable.push({
				field: "division_name",
				title: "Divisione",
				headerCell: "myDivisionsHeaderTemplate",
				cell: "myDivisionsCellTemplate",
				filterable: true
			});
			this.hasDivisions = true;
		}

		self.columnsTable.push({
			field: "recipients",
			title: "Destinatari",
			headerCell: "myHeaderTemplate",
			cell: "myCellTemplateNotRequired",
			filterable: true
		});
		self.columnsTable.push({
			field: "recipients_Bcc",
			title: "Destinatari in copia",
			headerCell: "myHeaderTemplate",
			cell: "myCellTemplateNotRequired",
			filterable: true
		});
		self.columnsTable.push({
			field: "sms_numbers",
			title: "Destinatari sms",
			headerCell: "myHeaderTemplate",
			cell: "myCellTemplateNotRequired",
			filterable: true
		});

		this.columnsTable.push({
			cell: "myCellDeleteTemplate",
			width: "45px",
			sortable: false,
			headerCell: "myHeaderTemplate"
		});

		if (this.geofenceId == 0) {
			this.isNewGeofence = true;
		}

		var newItem = {
			id: 0,
			geofence_id: this.geofenceId,
			type: 0,

			vehicle_id: 0,
			group_id: 0,
			division_id: 0,
			error: false,
			recipients: "",
			recipients_Bcc: "",
			sms_numbers: ""
		};
		this.defaultAddRow = newItem;

		if (this.isNewGeofence) {
			this.days = [
				{
					id: 0,
					active: true,
					weekday_number: 0,
					weekday_name: this.settings.commonLabels.weekday0,
					timeslots: [
						{
							from_time: moment("00:00", "HH:mm").format(),
							to_time: moment("23:59", "HH:mm").format()
						}
					]
				},
				{
					id: 0,
					active: true,
					weekday_number: 1,
					weekday_name: this.settings.commonLabels.weekday1,
					timeslots: [
						{
							from_time: moment("00:00", "HH:mm").format(),
							to_time: moment("23:59", "HH:mm").format()
						}
					]
				},
				{
					id: 0,
					active: true,
					weekday_number: 2,
					weekday_name: this.settings.commonLabels.weekday2,
					timeslots: [
						{
							from_time: moment("00:00", "HH:mm").format(),
							to_time: moment("23:59", "HH:mm").format()
						}
					]
				},
				{
					id: 0,
					active: true,
					weekday_number: 3,
					weekday_name: this.settings.commonLabels.weekday3,
					timeslots: [
						{
							from_time: moment("00:00", "HH:mm").format(),
							to_time: moment("23:59", "HH:mm").format()
						}
					]
				},
				{
					id: 0,
					active: true,
					weekday_number: 4,
					weekday_name: this.settings.commonLabels.weekday4,
					timeslots: [
						{
							from_time: moment("00:00", "HH:mm").format(),
							to_time: moment("23:59", "HH:mm").format()
						}
					]
				},
				{
					id: 0,
					active: true,
					weekday_number: 5,
					weekday_name: this.settings.commonLabels.weekday5,
					timeslots: [
						{
							from_time: moment("00:00", "HH:mm").format(),
							to_time: moment("23:59", "HH:mm").format()
						}
					]
				},
				{
					id: 0,
					active: true,
					weekday_number: 6,
					weekday_name: this.settings.commonLabels.weekday6,
					timeslots: [
						{
							from_time: moment("00:00", "HH:mm").format(),
							to_time: moment("23:59", "HH:mm").format()
						}
					]
				}
			];
			this.isGeofenceDetailInEditMode = true;
		}

		try {
			let optionsMessages = kendo.widgets.find(function(item) {
				return item.name == "kendoDateInput";
			});
			optionsMessages.widget.fn.options.messages.hour = "HH";
			optionsMessages.widget.fn.options.messages.minute = "mm";
		} catch (ex) {
			//do nothing
		}

		this.getGeofenceVehicleTypes();
		this.getAllVehicles();
		this.getGroups();
		if (this.hasDivisions) this.getDivisions();
		this.getPoiCategories();
	},

	mounted() {
		
	},

	watch: {
		// checkIn: function (newValue) {
		// 	if (!newValue && !this.checkOut) {
		// 		this.checkOut = true;
		// 	}
		// },
		// checkOut: function (newValue) {
		// 	if (!newValue && !this.checkIn) {
		// 		this.checkIn = true;
		// 	}
		// },
	},

	beforeDestroy() {
		try {
			var optionsMessages = kendo.widgets.find(function(item) {
				return item.name == "kendoDateInput";
			});
			optionsMessages.widget.fn.options.messages.hour = "hours";
			optionsMessages.widget.fn.options.messages.minute = "minutes";
		} catch (ex) {
			//do nothing
		}
	},

	methods: {
		onModalShown() {			
			this.isModalShown = true;
		},
		onModalHidden() {
			this.isModalShown = false;
		},
		internalFiltersToUpdate(e) {
			if (e.field == "vehicle_name") {
				this.plateNumberFilterSelected = [];
			}
			if (e.field == "group_name") {
				this.groupsDataFiltersSelected = [];
			}
			if (e.field == "division_name") {
				this.divisionsFilterSelected = [];
			}
		},
		getGeofenceVehicleTypes() {
			var self = this;
			ApiService.getGeofenceVehicleTypes().then(res => {
				self.geofenceVehicleTypes = res.map(function(item) {
					return {
						id: item.key,
						value: item.value
					};
				});
			});
		},
		isNumber: function(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		addRowItem(e) {
			this.addItem(e);

			for (var i = 0; i < this.items.length; i++) {
				var row = this.items[i];
				console.log(row);
				if (row.type == 0) {
					row.group_id = null;
					row.division_id = null;
				} else if (row.type == 1) {
					row.vehicle_id = null;
					row.division_id = null;
				} else if (row.type == 2) {
					row.vehicle_id = null;
					row.group_id = null;
				}
			}

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		removeRow(e) {
			this.remove(e);

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (
							(item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) ||
							(item.type == itemToCheck.type && item.type == 1 && item.group_id == itemToCheck.group_id) ||
							(item.type == itemToCheck.type && item.type == 2 && item.division_id == itemToCheck.division_id)
						) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onTypeChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newType = this.geofenceVehicleTypes.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.type = newType.id;
			}

			// //clear value fixed columns
			// row.recipients = "";
			// row.recipients_Bcc = "";
			// row.sms_numbers = "";

			//preload value based on type selected
			if (newType && newType.id == 0) {
				if (this.vehicles && this.vehicles.length > 0) {
					row.vehicle_id = this.vehicles[0].id;
				}

				row.group_id = null;
				row.division_id = null;
			} else if (newType && newType.id == 1) {
				if (this.groups && this.groups.length > 0) {
					row.group_id = this.groups[0].id;
				}

				row.vehicle_id = null;
				row.division_id = null;
			} else if (newType && newType.id == 2) {
				if (this.divisions && this.divisions.length > 0) {
					row.division_id = this.divisions[0].id;
				}

				row.vehicle_id = null;
				row.group_id = null;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (
							(item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) ||
							(item.type == itemToCheck.type && item.type == 1 && item.group_id == itemToCheck.group_id) ||
							(item.type == itemToCheck.type && item.type == 2 && item.division_id == itemToCheck.division_id)
						) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onVehicleChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newVehicle = this.vehicles.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.vehicle_id = newVehicle.id;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 0 && item.vehicle_id == itemToCheck.vehicle_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onGroupChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newGroup = this.groups.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.group_id = newGroup.id;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 1 && item.group_id == itemToCheck.group_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},
		onDivisionChange(e, rowId) {
			var newValue = e.sender.value();

			var row = this.items.find(function(item) {
				return item.id === rowId;
			});

			var newDivision = this.divisions.find(item => {
				return item.id == newValue;
			});

			if (row) {
				row.division_id = newDivision.id;
			}

			this.itemChange({
				dataItem: row
			});

			//check for same row value selected
			if (this.items && this.items.length > 0) {
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					Vue.set(item, "error", false);
				}

				let foundError = false;
				for (let i = 0; i < this.items.length; i++) {
					let item = this.items[i];
					for (let j = i + 1; j < this.items.length; j++) {
						let itemToCheck = this.items[j];

						if (item.type == itemToCheck.type && item.type == 2 && item.division_id == itemToCheck.division_id) {
							Vue.set(item, "error", true);
							Vue.set(itemToCheck, "error", true);

							let errors = {
								messages: [{ type: "error", text: "Le righe non possono contenere gli stessi valori" }]
							};

							if (!foundError) {
								foundError = true;
								bus.$emit("responseNotification", errors);
							}
						}
					}
				}
			}
		},

		getAllVehicles: function() {
			var self = this;
			ApiService.getVehiclesLookup({ page: 0, pageSize: 1000000 }, this.vehicleIdFilterField).then(res => {
				self.vehicles = res.items.map(function(vehicle) {
					return {
						id: vehicle.id,
						name: vehicle.name,
						number_plate: vehicle.number_plate ? vehicle.number_plate : "",
						name_numberplate: `${vehicle.number_plate} ${vehicle.name}`
					};
				});

				self.getVehiclesByGeofenceId();

				self.vehicles = self._.sortBy(self.vehicles, function(vc) {
					return vc.number_plate.toLowerCase();
				});

				for (var i = 0; i < self.vehicles.length; i++) {
					var vehicle = self.vehicles[i];

					if (vehicle.number_plate) {
						var alreadyExist =
							self.plateNumberFilters.findIndex(item => {
								return item.id == vehicle.number_plate;
							}) >= 0;
						if (!alreadyExist) {
							self.plateNumberFilters.push({
								id: vehicle.number_plate,
								value: vehicle.number_plate
							});
						}
					}
				}

				if (self.vehicles && self.vehicles.length > 0) {
					self.defaultAddRow.vehicle_id = self.vehicles[0].id;
				}
			});
		},
		getGroups: function() {
			var self = this;
			return new Promise(function(resolve, reject) {
				ApiService.getGroupsData()
					.then(res => {
						self.groups = res.map(function(item) {
							return {
								id: item.id,
								value: item.name ? item.name.toLowerCase() : ""
							};
						});

						self.groups = self._.sortBy(self.groups, ["value"]);
						self.groupsDataFilters = JSON.parse(
							JSON.stringify(
								self.groups.map(item => {
									return {
										id: item.value,
										value: item.value
									};
								})
							)
						);

						resolve();
					})
					.catch(err => {
						reject();
					});
			});
		},
		getDivisions() {
			var self = this;
			api.getDivisionsData().then(res => {
				self.divisions = self._.sortBy(
					res
						.filter(function(dv) {
							return dv.name.length > 0;
						})
						.map(function(item) {
							return {
								id: item.id,
								value: item.name.toLowerCase()
							};
						}),
					function(dv) {
						return dv.value;
					}
				);

				self.divisionsFilter = JSON.parse(
					JSON.stringify(
						self.divisions.map(item => {
							return {
								id: item.value,
								value: item.value
							};
						})
					)
				);
			});
		},
		getVehiclesByGeofenceId: function() {
			var self = this;
			var geofenceId = this.geofenceId;

			ApiService.getVehiclesByGeofenceId(geofenceId).then(res => {
				if (self._.isNull(res) === false && self._.isUndefined(res) === false && self._.isArray(res) && res.length > 0) {
					self.items = res.map(function(item) {
						return {
							id: item.id,
							geofence_id: item.geofence_id,
							type: item.type,
							type_name: self.getTypeAssociationById(item.type),
							vehicle_id: item.vehicle_id ? item.vehicle_id : self.vehicles ? self.vehicles[0].id : null,
							vehicle_name: self.getVehiclePlateCodeById(item.vehicle_id),
							division_id: item.division_id ? item.division_id : self.divisions && self.divisions.length > 0 ? self.divisions[0].id : null,
							division_name: self.getDivisionNameById(item.division_id),
							group_id: item.group_id ? item.group_id : self.groups && self.groups.length > 0 ? self.groups[0].id : null,
							group_name: self.getGroupNameById(item.group_id),
							recipients: item.recipients,
							recipients_Bcc: item.recipients_Bcc,
							sms_numbers: item.sms_numbers,

							//custom prop
							error: false
						};
					});
				}
			});
		},
		getData() {
			var self = this;
			var geofenceId = this.geofenceId;

			if (!this.isNewGeofence) {
				ApiService.getGeofenceDetailData(geofenceId)
					.then(res => {
						if (self._.isNull(res.data) === false) {
							let data = res;

							self.id = data.id;
							self.name = data.name;
							self.checkIn = data.check_in;
							self.checkOut = data.check_out;
							self.useApiRoads = data.use_api_roads;
							self.startDate = data.start_date ? moment(data.start_date) : null;
							self.endDate = data.end_date ? moment(data.end_date) : null;
							self.days = data.days;

							self.poi = self.getDescriptionOfPoisSelected(data.pois) || [{ key: 0, value: "" }];
							self.poiItemsSelected = data.pois || [];
						}
					})
					.catch(err => {
						//do nothing
					});
			}
		},
		getDescriptionOfPoisSelected(pois) {
			var self = this;
			if (pois && pois.length > 0) {
				let poiKV = pois.map(function(item) {
					return {
						key: item,
						value: self.getPoiName(item)
					};
				});

				return poiKV;
			}

			return null;
		},
		groupsToString(groups) {
			if (this._.isNull(groups) === false && this._.isUndefined(groups) === false && this._.isArray(groups) && groups.length > 0) {
				var str = "";
				groups = this._.sortBy(groups, function(it) {
					return it.value ? it.value.toLowerCase() : "";
				});
				groups.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		switchGeofenceDetailEditMode() {
			this.isGeofenceDetailInEditMode = !this.isGeofenceDetailInEditMode;

			if (!this.isGeofenceDetailInEditMode) {
				this.getData();
			}

			this.savePendingRequest = null;
		},
		switchEditMode() {
			this.isInEditMode = !this.isInEditMode;

			if (!this.isInEditMode) {
				this.clearWorkingData();
				this.getVehiclesByGeofenceId();
			} else {
				for (var i = 0; i < this.items.length; i++) {
					var row = this.items[i];

					if (row.type == 0) {
						row.group_id = null;
						row.division_id = null;
					} else if (row.type == 1) {
						row.vehicle_id = null;
						row.division_id = null;
					} else if (row.type == 2) {
						row.vehicle_id = null;
						row.group_id = null;
					}
				}
			}

			this.saveGeofenceVechilesAssociationRequest = null;
		},
		saveGeofenceDetail() {
			var self = this;

			var data = {
				id: this.geofenceId,
				name: this.name,
				check_in: this.checkIn,
				check_out: this.checkOut,
				use_api_roads: this.useApiRoads,
				start_date: this.startDate && moment(this.startDate).isValid() ? moment(this.startDate).format() : null,
				end_date: this.endDate && moment(this.endDate).isValid() ? moment(this.endDate).format() : null,
				days: this.days,
				pois: this.poiItemsSelected
			};

			if (this.savePendingRequest == null) {
				this.savePendingRequest = ApiService.saveGeofenceDetail(data)
					.then(res => {
						self.isGeofenceDetailInEditMode = false;

						var id = res.data;
						if (self.isNewGeofence) {
							self.$router.push({
								name: "GEOFENCE_DETAIL",
								params: {
									id: id
								}
							});
							self.geofenceId = id;
							self.isNewGeofence = false;
							self.defaultAddRow.geofence_id = id;
						}

						self.getData();
					})
					.catch(err => {})
					.finally(_ => {
						self.savePendingRequest = null;
					});
			}
		},
		saveGeofenceVehiclesData() {
			var self = this;

			var createdItemsNormilized = [];
			for (let i = 0; i < this.createdItems.length; i++) {
				let item = this._.clone(this.createdItems[i]);

				if (item.type == 0) {
					item.group_id = null;
					item.division_id = null;
				}

				if (item.type == 1) {
					item.vehicle_id = null;
					item.division_id = null;
				}

				if (item.type == 2) {
					item.group_id = null;
					item.vehicle_id = null;
				}

				createdItemsNormilized.push(item);
			}

			var updatedItemsNormilized = [];
			for (let i = 0; i < this.updatedItems.length; i++) {
				let item = this._.clone(this.updatedItems[i]);

				if (item.type == 0) {
					item.group_id = null;
					item.division_id = null;
				}

				if (item.type == 1) {
					item.vehicle_id = null;
					item.division_id = null;
				}

				if (item.type == 2) {
					item.group_id = null;
					item.vehicle_id = null;
				}

				updatedItemsNormilized.push(item);
			}

			var deletedItemsNormilized = [];
			for (let i = 0; i < this.deletedItems.length; i++) {
				let item = this._.clone(this.deletedItems[i]);

				if (item.type == 0) {
					item.group_id = null;
					item.division_id = null;
				}

				if (item.type == 1) {
					item.vehicle_id = null;
					item.division_id = null;
				}

				if (item.type == 2) {
					item.group_id = null;
					item.vehicle_id = null;
				}

				deletedItemsNormilized.push(item);
			}

			this.saveGeofenceVechilesAssociationRequest = ApiService.saveGeofenceVehiclesAssociation(createdItemsNormilized, updatedItemsNormilized, deletedItemsNormilized)
				.then(res => {
					self.clearWorkingData();
					self.getVehiclesByGeofenceId();

					self.isGeofenceDetailInEditMode = false;
					self.getData();
				})
				.catch(err => {})
				.finally(_ => {
					self.saveGeofenceVechilesAssociationRequest = null;
				});
		},
		dateStringToMomentFormat(dateString) {
			if (dateString.indexOf("/") >= 0) {
				return moment(dateString, "DD/MM/YYYY").format();
			}

			return moment(dateString).format();
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		},
		isReadOnlyCell(field, item) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (item.id > 0 && c && c.readonly) {
					return true;
				}
			}

			return false;
		},

		startDateChange(item) {
			var newStartDate = moment(item.sender.value()).startOf("days");
			if (newStartDate > moment(this.endDate)) {
				var m = moment(item.sender.value()).endOf("days");
				this.endDate = m;
			}
			this.startDate = newStartDate;
		},
		endDateChange(item) {
			var newEndDate = moment(item.sender.value()).endOf("days");
			if (newEndDate < moment(this.startDate)) {
				var m = moment(item.sender.value()).startOf("days");
				this.startDate = m;
			}
			this.endDate = newEndDate;
		},
		removeHourByDay(item, index) {
			if (index >= 0) {
				item.timeslots.splice(index, 1);
			}
		},
		addHourByDay(item, index) {
			if (this.isGeofenceDetailInEditMode) {
				//reset errors
				for (var i = 0; i < this.errorsStartTime.length; i++) {
					Vue.set(this.errorsStartTime, i, false);
					Vue.set(this.errorsEndTime, i, false);
				}

				var isValidRange = true;
				var errors = {
					messages: []
				};
				var startDateElementRef = `starttimepicker_${index}`;
				var endDateElementRef = `endtimepicker_${index}`;

				var startTime = this.$refs[startDateElementRef][0].$el.value;
				var endTime = this.$refs[endDateElementRef][0].$el.value;

				if (!startTime || !endTime) {
					errors.messages.push({ type: "error", text: "Specificare una data di inizio e fine per la fascia" });
					bus.$emit("responseNotification", errors);

					return;
				}

				var strStartTimeCheck = startTime.replace(":", "");
				if (isNaN(strStartTimeCheck)) {
					errors.messages.push({ type: "error", text: "Specificare una data di inizio valida per la fascia" });
					Vue.set(this.errorsStartTime, index, true);

					isValidRange = false;
				}

				var strEndTimeCheck = endTime.replace(":", "");
				if (isNaN(strEndTimeCheck)) {
					errors.messages.push({ type: "error", text: "Specificare una data di fine valida per la fascia" });
					Vue.set(this.errorsEndTime, index, true);

					isValidRange = false;
				}

				if (!isValidRange) {
					bus.$emit("responseNotification", errors);
					return;
				}

				var mStartTime = moment(startTime, "HH:mm");
				var mEndTime = moment(endTime, "HH:mm");

				if (mStartTime.isValid && mEndTime.isValid) {
					if (mStartTime > mEndTime) {
						Vue.set(this.errorsStartTime, index, true);
						Vue.set(this.errorsEndTime, index, true);

						errors.messages.push({ type: "error", text: "L'oraro di fine deve essere maggiore di quello di inizio" });
						bus.$emit("responseNotification", errors);
						return;
					}

					for (var i = 0; i < item.timeslots.length; i++) {
						let tt = item.timeslots[i];
						tt.error = false;
						let ttStartNow = moment(tt.from_time);
						let ttStartTime = moment(ttStartNow).format("HH:mm");

						let ttEndNow = moment(tt.to_time);
						let ttEndTime = moment(ttEndNow).format("HH:mm");

						let ttStartTimeNow = moment(ttStartTime, "HH:mm");
						let ttEndTimeNow = moment(ttEndTime, "HH:mm");

						if (ttStartTimeNow <= mEndTime && ttEndTimeNow >= mStartTime) {
							Vue.set(this.errorsStartTime, index, true);
							Vue.set(this.errorsEndTime, index, true);

							tt.error = true;

							errors.messages.push({ type: "error", text: "La fascia si sovrappone con una esistente" });
							bus.$emit("responseNotification", errors);
							return;
						}
					}

					item.timeslots.push({
						from_time: mStartTime.format(),
						to_time: mEndTime.format()
					});

					this.$refs[startDateElementRef][0].$el.value = "HH:mm";
					this.$refs[endDateElementRef][0].$el.value = "HH:mm";
				}
			}
		},
		getPoiCategories() {
			var self = this;
			ApiService.getPoiCategoriesData().then(res => {
				self.poiCategories = res.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						description: item.description,
						background_color: item.background_color || null,
						icon_image: item.icon_image
					};
				});

				if (self.poiCategories.length > 0) {
					self.poiCategoriesSelected = _.toString(self.poiCategories[0].id);
				}

				self.getPOI();
			});
		},
		getPOI() {
			var self = this;
			this.loading = true;

			let params = {
				page: 0,
				pageSize: 100000
			};

			ApiService.getPoisData(params).then(res => {
				self.poiItems = res.items.map(function(item) {
					return {
						id: item.id,
						name: item.name,
						poi_category_id: item.poi_category_id,
						poi_category_name: self.getPoiDescription(item.poi_category_id),
						poi_category_icon_image: self.getPoiIconImgae(item.poi_category_id),
						poi_category_fill_color: self.getPoiFillColor(item.poi_category_id),
						radius: item.radius,
						location: item.location
					};
				});

				this.getData();
			});
		},
		getPoiName(poiId) {
			if (this.poiItems && this.poiItems.length > 0) {
				var poi = this.poiItems.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.name;
			}

			return poiId;
		},
		getPoiDescription(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.name;
			}

			return poiId;
		},
		getPoiFillColor(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi) return poi.background_color;
			}

			return "#000";
		},
		getPoiIconImgae(poiId) {
			if (this.poiCategories && this.poiCategories.length > 0) {
				var poi = this.poiCategories.find(function(item) {
					return item.id == poiId;
				});

				if (poi && poi.icon_image) return poi.icon_image;
				else return "/assets/map/icon/blank.png";
			}

			return null;
		},
		poiToString(poi) {
			if (this._.isNull(poi) === false && this._.isUndefined(poi) === false && this._.isArray(poi) && poi.length > 0) {
				var str = "";
				poi = this._.sortBy(poi, function(it) {
					return it.value ? it.value.toLowerCase() : "";
				});
				poi.forEach(element => {
					str += element.value + ", ";
				});

				str = str.replace(/, $/, "");
				return str;
			}

			return "";
		},
		openPoiMap(dataItem) {
			var self = this;
			if (this.poiItems && this.poiItems.length > 0) {
				var geofenceMarkerToShow = [];

				for (var i = 0; i < this.poiItemsSelected.length; i++) {
					let idItem = self.poiItemsSelected[i];
					let pItem = self.poiItems.find(function(item) {
						return item.id == idItem;
					});

					if (pItem) {
						geofenceMarkerToShow.push(pItem);
					}
				}
				this.geofenceMarker = geofenceMarkerToShow;
			}

			this.showPoiModal = true;
		},
		closePoiModal() {
			this.showPoiModal = false;
			this.geofenceMarker = [];
		},
		getTypeAssociationById(typeId) {
			let type = this.geofenceVehicleTypes.find(function(item) {
				return item.id == typeId;
			});

			if (type) return type.value;

			return typeId;
		},
		getVehiclePlateCodeById(vehicleId) {
			let vehicle = this.vehicles.find(function(item) {
				return item.id == vehicleId;
			});

			if (vehicle) return vehicle.number_plate;

			return vehicleId;
		},
		getGroupNameById(groupId) {
			let group = this.groups.find(function(item) {
				return item.id == groupId;
			});

			if (group) return group.value;

			return groupId;
		},
		getDivisionNameById(divisionId) {
			let division = this.divisions.find(function(item) {
				return item.id == divisionId;
			});

			if (division) return division.value;

			return divisionId;
		}
	},

	computed: {
		...mapGetters(["settings"]),
		startDateString() {
			if (this.startDate && this.startDate.isValid()) return moment(this.startDate).format("DD MMMM YYYY");
			return "";
		},
		endDateString() {
			if (this.endDate && this.endDate.isValid()) return moment(this.endDate).format("DD MMMM YYYY");
			return "";
		},
		poiString() {
			return this.poiToString(this.poi);
		},
		columns: function() {
			return this.columnsTable;
		}
	}
};
